import { MOBILE } from '_pixiSrc/layout/features';
import {
    APP,
    ALIGN,
    VALIGN,
} from '_pixiSrc/globals';
import {
    Utils,
} from '_pixiSrc/Utils';
import Sprite from '_pixiSrc/display/Sprite';
import I18 from '_pixiSrc/I18';
import Static from '../libraries/Static';
import Button from '../ui/Button';
import DynamicData from '../ui/DynamicData';
import NetworkController from '../network/NetworkController';
import TextPanel from '../ui/TextPanel';
import GameData from '../ui/GameData';
import GameConfig from '../libraries/GameConfig';
import AudioManager from '../ui/AudioManager';

let cardHistoryArr = []; // 0 - red, 1 - black

class GambleGame extends Sprite {
    constructor(side = 'right', collectButtonParent) {
        super();

        GameData.setProperty('isGambleActive', true);
        GameData.setProperty('isGambleGame', true);

        this.winAnimationPlayed = false;

        this.buttons = {};
        this.exitHandler = () => { };

        this.collectButtonParent = collectButtonParent;

        this.isButtonsEnable = true;

        this.side = side;

        this.on('pointerclick', () => false);

        this.once('added', Utils.proxy(this._init, this));
    }

    _init() {
        TextPanel.sendMessage('clickSpin');
        this._buildScreen();
    }

    _buildDesktop() {
        /* BUTTONS */
        this.buttons.collect = this.addChild(new Button('buttons/buttons/collect', 0, -62, 0.65, () => {
            NetworkController.takeWinAmount();
            this.exitHandler();
        }));
        this.buttons.collect.hitArea = new PIXI.RoundedRectangle(-63, -15, 126, 63, 32);
        this.buttons.collect.text = Static.writeNativeText(this.buttons.collect, I18.f('take'), 'lato-regular', 0, 30, {
            fill: 0xfcd781,
            align: ALIGN.CENTER,
            weight: 'bold',
            size: 20,
        });
        Static.setScaleToFitWidthNativeText(this.buttons.collect.text, 100, 0.5, 1);

        this.buttons.startGamble = this.addChild(new Button('buttons/buttons/gamble', 0, 2, 0.65));
        this.buttons.startGamble.disable();
        this.buttons.startGamble.hitArea = new PIXI.RoundedRectangle(-63, -47, 126, 63, 32);
        this.buttons.startGamble.text = Static.writeNativeText(this.buttons.startGamble, I18.f('gamble'), 'lato-regular', 0, -30, {
            fill: 0xfcd781,
            align: ALIGN.CENTER,
            weight: 'bold',
            size: 20,
        });
    }

    changeOrientation() {
        for (const v in this.buttons) {
            if (this.buttons[v] && this.buttons[v].safeRemove) {
                this.buttons[v].safeRemove();
            }
        }
        this._buildMobile();
    }

    _buildMobile() {
        const gambleButtonState = {
            normal: 0,
            hover: 0,
            pressed: 0,
            disable: 3,
        };

        this.position.set(0, 234);

        if (APP.layout.orientation === 'landscape') {
            if (this.side === '' || this.side === 'right') {
                this.buttons.collect = this.addChild(new Button('buttons/buttons/line-back', 385, -230, 1.3, () => {
                    NetworkController.takeWinAmount();
                    this.exitHandler('right');
                }, gambleButtonState));
                this.buttons.collect.hitArea = new PIXI.Circle(0, 0, 27);
                this.buttons.collect.text = Static.writeNativeText(this.buttons.collect, I18.f('take'), 'lato-regular', 0, 0, {
                    fill: 0xfcd781,
                    align: ALIGN.CENTER,
                    weight: 'bold',
                    size: 14,
                });
                Static.setScaleToFitWidthNativeText(this.buttons.collect.text, 45, 0.5, 1);
            }
            if (this.side === '' || this.side === 'left') {
                this.buttons.collectLeft = this.addChild(new Button('buttons/buttons/line-back', 385, -230, 1.3, () => {
                    NetworkController.takeWinAmount();
                    this.exitHandler('left');
                }, gambleButtonState));
                this.buttons.collectLeft.hitArea = new PIXI.Circle(0, 0, 27);
                this.buttons.collectLeft.text = Static.writeNativeText(this.buttons.collect, I18.f('take'), 'lato-regular', 0, 0, {
                    fill: 0xfcd781,
                    align: ALIGN.CENTER,
                    weight: 'bold',
                    size: 14,
                });
                Static.setScaleToFitWidthNativeText(this.buttons.collectLeft.text, 45, 0.5, 1);
            }
        } else {
            this.buttons.collect = this.collectButtonParent.addChild(new Button('buttons/buttons/collect', 0, -262, 1.5, () => {
                NetworkController.takeWinAmount();
                this.exitHandler();
            }, gambleButtonState));
            this.buttons.collect.hitArea = new PIXI.RoundedRectangle(-63, -15, 126, 63, 32);
            this.buttons.collect.text = Static.writeNativeText(this.buttons.collect, I18.f('take'), 'lato-regular', 0, 30, {
                fill: 0xfcd781,
                align: ALIGN.CENTER,
                weight: 'bold',
                size: 20,
            });
            Static.setScaleToFitWidthNativeText(this.buttons.collect.text, 100, 0.5, 1);

            this.buttons.startGamble = this.collectButtonParent.addChild(new Button('buttons/buttons/gamble', 0, -115, 1.5));
            this.buttons.startGamble.disable();
            this.buttons.startGamble.hitArea = new PIXI.RoundedRectangle(-63, -47, 126, 63, 32);
            this.buttons.startGamble.text = Static.writeNativeText(this.buttons.startGamble, I18.f('gamble'), 'lato-regular', 0, -30, {
                fill: 0xfcd781,
                align: ALIGN.CENTER,
                weight: 'bold',
                size: 20,
            });
        }

        // this.buttons.red = this.addChild(new Button('mobile_buttons/gambleRedButton', -90, -60, 1, () => this.gamble(0)));

        // this.buttons.black = this.addChild(new Button('mobile_buttons/gambleBlackButton', 90, -60, 1, () => this.gamble(1)));
        // this.buttons.exit = this.addChild(new Button('mobile_buttons/take_money_round_up', 390, -160, 1, () => {
        //   NetworkController.takeWinAmount();
        //   this.exitHandler();
        // }));

        // if (GameData.getProperty("isLeftHand")) {
        //   this.buttons.exit.x = -390;
        // }

        // let lb1 = this.addChild(new Button('mobile_buttons/linesDisableButton', -368, 20));
        // lb1.text = DynamicData.write(lb1, 'lines', 'font_num_new', 0, 5, {}, () => { }, {
        //   "width": 80,
        //   "min": 0.8,
        //   "max": 0.8
        // });
        // lb1.text.scaleTo(0.8);
        // lb1.textInfo = Static.writeText(lb1, I18.f('lines'), 'font_gold4', 0, -20, {
        //   "align": ALIGN.CENTER
        // });
        // lb1.textInfo.scaleTo(0.28);
        // lb1.disable();

        // let lb2 = this.addChild(new Button('mobile_buttons/totalBetDisableButton', -313, 20));
        // lb2.text = DynamicData.write(lb2, 'totalBet', 'font_num_new', 0, 5, {
        //   "spaceDivider": true
        // }, () => { }, {
        //     "width": 90,
        //     "min": 0.5,
        //     "max": 0.7
        //   });
        // lb2.textInfo = Static.writeText(lb2, I18.f('totalBet'), 'font_gold4', 0, -19, {
        //   "align": ALIGN.CENTER
        // });
        // lb2.textInfo.scaleTo(0.28);
        // lb2.disable();
    }

    _buildScreen() {
        /* MAIN */
        this.mainScreen = this.addChild(APP.library.getSprite('gamble_game/back'));
        this.mainScreen.scale.set(0.4);
        this.mainScreen.scaleTo(1, GameConfig.layoutFadeInOutTime);
        this.mainScreen.y = -234;

        this.totalTextInfo = Static.writeText(this.mainScreen, I18.f('gambleAmount').toUpperCase(), 'font_yellow_03', -290, 110);
        this.totalText = DynamicData.write(this.mainScreen, 'lastWin', 'font_gold1_06', -290, 128, {
            spaceDivider: true,
        }, null, {
            width: 140,
            min: 0.1,
            max: 1,
        });

        this.gambleWinInfo = Static.writeText(this.mainScreen, I18.f('gambleWin').toUpperCase(), 'font_yellow_03', 290, 110);
        this.gambleWin = DynamicData.write(this.mainScreen, 'GGWin', 'font_gold1_06', 290, 128, {
            spaceDivider: true,
        }, null, {
            width: 140,
            min: 0.1,
            max: 1,
        });

        this.header = Static.writeText(this.mainScreen, I18.f('allOrNothing').toUpperCase(), 'font_yellow_gradient', 0, -170);
        this.subHeader = Static.writeText(this.mainScreen, I18.f('chooseACard').toUpperCase(), 'font_yellow', 0, -120);

        this.howToPlayHeader = Static.writeText(this.mainScreen, I18.f('howToPlayHeader').toUpperCase(), 'font_how_to_play_dark_yellow', -291, -60);

        // -380
        this.howToPlay1 = Static.writeText(this.mainScreen, I18.f('howToPlay1'), 'font_how_to_play_yellow_07', -291, -32, {
            scale: 1,
            align: ALIGN.CENTER,
            valign: VALIGN.TOP,
            width: 240,
        });
        this.howToPlay2 = Static.writeText(this.mainScreen, I18.f('howToPlay2'), 'font_how_to_play_white_07', -291, this.howToPlay1.y + this.howToPlay1.getHeight() * this.howToPlay1.scale.x, {
            scale: 1,
            align: ALIGN.CENTER,
            valign: VALIGN.TOP,
            width: 240,
        });

        this.howToPlay3 = Static.writeText(this.mainScreen, I18.f('howToPlay3'), 'font_how_to_play_yellow_07', -291, this.howToPlay2.y + this.howToPlay2.getHeight() * this.howToPlay2.scale.x, {
            scale: 1,
            align: ALIGN.CENTER,
            valign: VALIGN.TOP,
            width: 240,
        });
        this.howToPlay4 = Static.writeText(this.mainScreen, I18.f('howToPlay4'), 'font_how_to_play_yellow_07', -291, this.howToPlay3.y + this.howToPlay3.getHeight() * this.howToPlay3.scale.x, {
            scale: 1,
            valign: VALIGN.TOP,
        });

        this.historyHeader = Static.writeText(this.mainScreen, I18.f('historyHeader').toUpperCase(), 'font_how_to_play_dark_yellow', 290, -60);

        this.howToPlayHeader.setScaleToFitWidth(186, 0.1, 1);
        this.historyHeader.setScaleToFitWidth(186, 0.1, 1);

        const scale = Math.min(this.howToPlayHeader.scale.x, this.historyHeader.scale.x);
        this.howToPlayHeader.scale.set(scale);
        this.historyHeader.scale.set(scale);

        this.shadow0 = this.mainScreen.addChild(APP.library.getSprite('gamble_game/shadow-0'));
        this.shadow0.position.set(-100, 40);
        this.shadow0.visible = false;

        this.shadow1 = this.mainScreen.addChild(APP.library.getSprite('gamble_game/shadow-1'));
        this.shadow1.position.set(100, 35);
        this.shadow1.visible = false;

        this.card0 = this._addCard(0);
        this.card1 = this._addCard(1);

        if (MOBILE) {
            this._buildMobile();
        } else {
            this._buildDesktop();
        }

        DynamicData.setValue('GGWin', DynamicData.getValue('lastWin') * 2);
        DynamicData.setValue('GGCollected', 0);

        this.redAnim = this.card0.addChild(APP.library.getSprite('gamble_game/shine-red'));
        this.redAnim.position.set(-70, -120);
        this.blackAnim = this.card1.addChild(APP.library.getSprite('gamble_game/shine-black'));
        this.blackAnim.position.set(70, -120);

        animateBlink(this.redAnim);
        animateBlink(this.blackAnim, 1);

        function animateBlink(card, opTo = 0) {
            card.fadeTo(opTo, 500, null, () => card.fadeTo(1 - opTo, 500, null, () => animateBlink(card, opTo)));
        }

        this._animateCards();

        if (!GameData.getProperty('demoPlay')) {
            NetworkController.getGambleHistory((data) => {
                cardHistoryArr = data;
                this.refreshCardHistory();
            });
        } else {
            this.refreshCardHistory();
        }
    }

    _addCard(id) {
        const card = this.mainScreen.addChild(APP.library.getSprite(`gamble_game/${id === 0 ? 'red-card' : 'black-card'}`));
        card.position.set(id === 0 ? -100 : 100, 40);

        card.on('pointerclick', () => this.gamble(id));
        card.on('changeframe', () => {
            if (!this.winAnimationPlayed) { AudioManager.playSound('fx', 'highlight_v2'); }
        });
        card.interactive = true;
        card.buttonMode = true;
        card.cursor = 'pointer';

        card._allTextures = card.textures;
        this._changeCardOverState(card, false);
        card.gotoAndStop(0);

        // card.on("mouseover", () => this._changeCardOverState(card, true));
        // card.on("mouseout", () => this._changeCardOverState(card, false));

        return card;
    }

    _changeCardOverState(card, over = false) {
        if (over) { card.textures = [card._allTextures[1], card._allTextures[3]]; } else { card.textures = [card._allTextures[0], card._allTextures[2]]; }
        card.texture = card.textures[card.currentFrame];
    }

    _setZIndexes(type = -1) { // -1 - default, 0 - red, 1 - black
        switch (type) {
            case -1:
                this.shadow0.zIndex = 10;
                this.shadow1.zIndex = 20;
                this.card0.zIndex = 30;
                this.card1.zIndex = 40;
                break;
            case 0:
                this.shadow0.zIndex = 30;
                this.shadow1.zIndex = 10;
                this.card0.zIndex = 40;
                this.card1.zIndex = 20;
                break;
            case 1:
                this.shadow0.zIndex = 10;
                this.shadow1.zIndex = 30;
                this.card0.zIndex = 20;
                this.card1.zIndex = 40;
                break;
            default:
                console.error('Wrong type of zIndex in Gamble Game');
        }
    }

    _animateCards() {
        this._setZIndexes(-1);

        this.isButtonsEnable = true;

        const animTime = 250; // frame change time
        const durationMultiplier = 1000 / animTime;

        animateCard(this.card0, 0);
        animateCard(this.card1, 1);

        function animateCard(card, frame = 0) {
            card.animationSpeed = (card.totalFrames / 60) * durationMultiplier;
            card.gotoAndPlay(frame);
        }
    }

    _stopAnimation() {
        this.card0.gotoAndStop(0);
        this.card1.gotoAndStop(0);
    }

    refreshCardHistory() {
        if (this.cardHistory) { this.cardHistory.safeRemove(); }

        this.cardHistory = this.mainScreen.addChild(new Sprite());
        this.cardHistory.x = 290;
        let history = cardHistoryArr;
        NetworkController.getGambleHistory((data) => {
            history = data;
        });
        for (let i = 0; i < 5; i++) {
            let sprite;
            const value = history[i];
            if (typeof value !== 'undefined') {
                if (value === 0) {
                    sprite = APP.library.getSprite('gamble_game/card-history-red');
                    sprite.gotoAndStop(0);
                } else {
                    sprite = APP.library.getSprite('gamble_game/card-history-black');
                    sprite.gotoAndStop(1);
                }

                const img = this.cardHistory.addChild(sprite);
                img.x = (i - 2) * 30;
            }
        }
    }

    disableButtons() {
        for (const key in this.buttons) {
            this.buttons[key].disable();
        }
    }

    enableButtons() {
        for (const key in this.buttons) {
            if (this.buttons.startGamble == this.buttons[key]) {
                continue;
            }
            this.buttons[key].enable();
        }
    }

    gamble(cardType) { // 0 - red, 1 - black
        if (!this.isButtonsEnable) { return; }

        AudioManager.playSound('fx', 'turn_card_v2');

        this.isButtonsEnable = false;

        const card = this[`card${cardType}`];

        this.lastPicked = cardType;
        this.disableButtons();

        NetworkController.getGambleGameResult(cardType, Utils.proxy(this._resultRequest, this));
    }

    _resultRequest(response) {
        // cardHistoryArr.unshift(response.gambleWon ? this.lastPicked : 1 - this.lastPicked);
        if (!response) {
            this.exitHandler();
            return;
        }
        this.refreshCardHistory();
        if (response.gambleWon) {
            this.correctPickHandler(response.isGambleAvailable);
            this.enableButtons();
        } else {
            this.incorrectPickHandler();
        }
    }

    correctPickHandler(next) {
        this._stopAnimation();

        this._setZIndexes(this.lastPicked);
        AudioManager.playSound('fx', 'gamble_win');

        this.winAnimationPlayed = true;

        const timeout = 2000;

        const winText = this.mainScreen.addChild(APP.library.getSprite('gamble_game/win'));
        winText.scaleTo(0.8);
        winText.scaleTo(1.2, timeout);

        // add a glow to the background
        const parent = this[`card${this.lastPicked}`];
        parent.play();
        const winCardGlow = parent.addChild(APP.library.getSprite(`gamble_game/lights-${this.lastPicked}`));

        setTimeout(() => {
            this._animateCards();
            winText.safeRemove();
            winCardGlow.safeRemove();
            this.winAnimationPlayed = false;
        }, timeout);

        const bet = +DynamicData.getValue('lastWin');

        DynamicData.addValue('lastWin', bet);
        DynamicData.setValue('GGWin', 0);
        DynamicData.addValue('GGWin', DynamicData.getValue('lastWin') * 2);
        DynamicData.addValue('GGCollected', bet);
        if (!next) {
            GameData.setProperty('isGambleGame', false);
            // NetworkController.takeWinAmount();
            setTimeout(() => this.exitHandler(), 2000);
        }
    }

    incorrectPickHandler() {
        this._stopAnimation();
        this._setZIndexes(this.lastPicked);
        AudioManager.playSound('fx', 'gamble_lose');

        const timeout = 1500;
        const parent = this[`card${1 - this.lastPicked}`];
        parent.gotoAndStop(1);

        GameData.setProperty('isGambleGame', false);
        DynamicData.setValue('lastWin', 0);
        DynamicData.setValue('GGWin', 0);
        setTimeout(() => this.exitHandler(), timeout);
    }

    finish() {
        for (const v in this.buttons) {
            this.buttons[v].safeRemove();
        }
        this.mainScreen.scaleTo(0.4, GameConfig.layoutFadeInOutTime, null, () => {
            this.safeRemove();
            GameData.setProperty('isGambleGame', false);
            if (DynamicData.getValue('lastWin') > 0 && DynamicData.getValue('GGWin') > 0) {
                TextPanel.sendMessage('totalWin', DynamicData.getValue('lastWin'));
            }
        });
    }
}

export default GambleGame;
